<template>
    <div :class="`DshNumber ycFormItem control-${mode}`">
        <!-- 组件无clearable -->
        <BriInputNumber
            style="width: 100%"
            :class="{
                'DshNumber-readonly': $isReadonly(canEdit, propsObj),
                'DshNumber-disabled': $isDisabled(canEdit, propsObj)
            }"
            v-model="value[propsObj._key]"
            :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
            :disabled="!finalCanEdit"
            :max="propsObj._max || Infinity"
            :formatter="getFormatter(propsObj)"
            :min="propsObj._min || -Infinity"
            :numberAdjust="!propsObj.inTable"
            :precision="propsObj._round === 'round' ? 0 : propsObj._digit && Number(propsObj._digit)"
            @on-change="change"
        >
            <div v-if="propsObj._unit" slot="suffix" style="padding-right: 24px;line-height: 30px;white-space: nowrap">{{propsObj._unit}}</div>
        </BriInputNumber>
        <!-- <template v-else>
            <Progress
                v-if="propsObj._showProgress"
                :percent="value[propsObj._key] > 100 ? 100 : toDecimal(value[propsObj._key])"
                :textInside="true"
                :strokeWidth="20"
                style="line-height:20px"
             />
             <Ctooltip
                v-else
                placement="top"
                :transfer="true"
                :content="String(format())"
              >
                 <span class="dsh-ellipsis">
                    {{ format() }}
                </span>
            </Ctooltip>
        </template> -->
    </div>
</template>

<script>
    import BriInputNumber from "./BriInputNumber/BriInputNumber.vue";
    import controlMixin from "../../controlMixin.js";

    export default {
        name: "DshNumber",
        components: {
            BriInputNumber
        },
        mixins: [controlMixin],
        props: {},
        data () {
            return {
                format: function () {
                    let propsObj = this.propsObj;
                    let val = this.value[propsObj._key];
                    if (val) {
                        if (propsObj._separator) {
                            return val && val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else if (propsObj._numberFormat == "percent") {
                            return `${val}%`;
                        } else {
                            return val;
                        }
                    }
                    return "";
                }
            };
        },
        computed: {
        },
        created () {
        },
        methods: {
            getFormatter (propsObj) {
                if (propsObj._separator) {
                    return value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else if (propsObj._numberFormat == "percent") {
                    return value => `${value}%`;
                } else {
                    return value => `${value}`;
                }
            },
            toDecimal (x) {
                let f = parseFloat(x);
                if (isNaN(f)) {
                    return;
                }
                f = Math.round(x * 100) / 100;
                return f;
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshNumber {
        width: 100%;
    }
</style>
<style lang="less">
    .DshNumber {
        .ivu-input-number-disabled .ivu-input-number-input {
            color:#999;
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshNumber/DshNumber.vue